<div class="p-4">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <div class="card-sub-heading title_size20">
      Update the prescription status as {{ props.item.DeliveryStatus }}?
    </div>
    <button mat-icon-button (click)="dialogRef.close()" type="button" [disabled]="isLoading">
      <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
  </div>
  <form [formGroup]="form" (ngSubmit)="formSubmit()">
    <div class="row py-2 no-gutters">
      <div class="col-md-12">
   
        <mat-checkbox class="example-margin bold mt-0" (change)="onCheckChange($event)"
          formControlName="NotifyUsers">
          Notify Users
        </mat-checkbox>
        <div class="row p-3" *ngIf="form.value.NotifyUsers">
          <div class="col-md-12">
            <div class="d-flex row pt-3">
              <ng-container formArrayName="NotifyUsersBy">
                <ng-container *ngFor="let item of notifyByArray.controls; let i = index">
                  <ng-container [formGroupName]="i">
                    <div class="col-md-4">
                      <mat-checkbox value="{{ item.value.id }}" [disabled]="item.value.disable" formControlName="isChecked">{{ item.value.value }}
                      </mat-checkbox>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <app-error-message [formName]="form" [fieldName]="'NotifyUsersBy'" [type]="'group'">
              </app-error-message>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row py-2">
      <div class="col-md-12">
        <div class="card-sub-heading grey">User Last Login</div>
        <div class="mt-2">Mon, Aug 16, 2021 6:27</div>
      </div>
    </div>
    <div class="row py-4" *ngIf="tenant == 'pl' || tenant == 'sl'">
      <div class="col-md-12">
        <mat-checkbox class="example-margin" formControlName="custom_message">Custom Message</mat-checkbox>
      </div>
    </div>
    <div class="row" *ngIf="this.form.value.custom_message">
      <div class="col-md-12" *ngIf="tenant == 'pl'">
        <div class="form-group">
          <textarea class="form-control height" formControlName="message"
            placeholder="We have Confirm your prescription. If you have any questions, please call/ text 1833 Pillway or download the pillway app. click here to download the app: http://pillway.page.link/jhj1"
            rows="3"></textarea>
          <app-error-message [formName]="form" [fieldName]="'message'" [type]="'group'">
          </app-error-message>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12 d-flex align-items-end justify-content-end">
        <button class="custom-btn" (click)="dialogRef.close()" type="button" [disabled]="isLoading">
          Cancel
        </button>
        <button class="custom-btn" type="submit" [disabled]="isLoading">
          {{ isLoading ? 'Confirming...' : 'Confirm' }}
          <span class="whiteLoader" *ngIf="isLoading"></span>
        </button>
      </div>
    </div>
  </form>
</div>
